/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';

import callActivityLinkStore from './CallActivityLinkStore';
import CallActivityLinkOverlay from './CallActivityLinkOverlay';

const CallActivityLinking = ({ isLoadingModeler, permission }) => {
  const { selectedCallActivity, isElementLinked } = callActivityLinkStore;

  let showOverlay = !isLoadingModeler && selectedCallActivity;
  if (permission.is(['COMMENT', 'READ'])) {
    if (!isElementLinked(selectedCallActivity)) {
      showOverlay = false;
    }
  }

  return (
    <>
      {showOverlay && (
        <CallActivityLinkOverlay element={selectedCallActivity} readOnly={permission.is(['COMMENT', 'READ'])} />
      )}
    </>
  );
};

export default observer(CallActivityLinking);
